"use client";
import TrustSecurityPage from "@/features/legal/TrustSecurityPage";

export default function TrustSecurityClient() {
  return <TrustSecurityPage />;
}
